// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__369WW","fileBtn":"File_fileBtn__KIMwH","closeBtn":"File_closeBtn__R6qz-","fileSelected":"File_fileSelected__2HmC8","disabled":"File_disabled__1wdvB"};